import "./movingtext.css";

export default function MovingText() {
    return (
        <div className="movingText__box" id="footer">
            <div className="movingText__wrapper">
                <p>EVERYTHING</p>
                <p>CHALLENGE</p> 
            </div>
        </div>
    )
}
